import React, { use, useEffect, useRef, useState } from "react";
import {
  Tabs,
  Button,
  Popconfirm,
  Dropdown,
  Modal,
  InputNumber,
  Space,
  Select,
  Drawer,
  notification,
} from "antd";
import {
  DownOutlined,
  UpOutlined,
  CheckOutlined,
  EditOutlined,
  InfoCircleOutlined,
  CloseOutlined,
  RightOutlined,
  CheckCircleFilled,
} from "@ant-design/icons";
import "./TradeRoom.css"; // we'll add smooth animation CSS
import TradeTable from "./TradeTable";
import { div, title, tr } from "framer-motion/client";
import { useLayout } from "../Context/LayoutContext";
import { motion, AnimatePresence, number } from "framer-motion";
import $ from "jquery";
import Axios from "../Axios";
import { message } from "antd"; // ✅ only if using Ant Design
import { Loader } from "../Loader/Loader";
import consts from "../consts";
import { useChartData } from "../Context/chartContext";
import { pre } from "framer-motion/m";
import success from "../Assets/success.mp3";
import lose from "../Assets/lose.mp3";
import { useFutureData } from "../Context/futureContext";
import { useCommodityData } from "../Context/commodityContext";
import socket from "../socket-io";
const { TabPane } = Tabs;

const SmoothAccordionTabs = ({ collapsedHistory, setCollapsedHistory }) => {
  const leverage = 300;
  const [collapsed, setCollapsed] = useState(true);
  const {
    tradeHistory,
    positions,
    type,
    setType,
    getTradeHistory,
    getPositions,
    getWallet,
    handleRemovePlotLines,
    activeKey,
    tabs,
    setTriggerForexOrders,
    openOrders,
  } = useLayout();
  const { priceRef, handleRemoveAllLines } = useChartData();
  const { getFutureTicker, handleFutureRemoveAllLines } = useFutureData();
  const { getCommodityTicker } = useCommodityData();
  const inputRef = useRef(null);
  const inputRefPip = useRef(null);
  const [val, setVal] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [load, setLoad] = useState(false);
  const [pip, setPip] = useState(0);
  const [sltp, setSlTp] = useState(0);
  const [futureSlTp, setFutureSlTp] = useState(0);
  const [futureSlTpMoney, setFutureSlTpMoney] = useState(0);
  const isMobilePoint = window.innerWidth <= 767;
  const [typeFilter, setTypeFilter] = useState("future");
  const [orderAssetFilter, setOrderAssetFilter] = useState("forex");
  const [orderHistoryAssetFilter, setOrderHistoryAssetFilter] = useState("all");
  const [closedPositions, setClosedPositions] = useState([]);
  const [mobileDraw, setMobileDraw] = useState(false);

  const isCommodityTradeSymbol = (symbol = "") => {
    const key = String(symbol).replace(/[/_]/g, "").toUpperCase();
    const COMMODITY_KEYS = new Set([
      "GOLD",
      "SILVER",
      "PLATINUM",
      "XAUUSD",
      "XAGUSD",
      "XPTUSD",
      "XAUUSDT",
      "XAGUSDT",
      "XPTUSDT",
    ]);
    return COMMODITY_KEYS.has(key);
  };

  const shouldIncludeTradeByOpenOrderFilter = (trade) => {
    if (orderAssetFilter === "all") return true;
    const isCommodity = isCommodityTradeSymbol(trade?.symbol);
    if (orderAssetFilter === "commodities") return isCommodity;
    if (orderAssetFilter === "forex") return !isCommodity;
    return true;
  };

  const shouldIncludeTradeByOrderHistoryFilter = (trade) => {
    if (orderHistoryAssetFilter === "all") return true;
    const isCommodity = isCommodityTradeSymbol(trade?.symbol);
    if (orderHistoryAssetFilter === "commodities") return isCommodity;
    if (orderHistoryAssetFilter === "forex") return !isCommodity;
    return true;
  };

  const getSocketDomSymbol = (symbol = "") => {
    const key = String(symbol).replace(/[/_]/g, "").toUpperCase();
    if (["GOLD", "XAUUSD", "XAU", "XAUUSDT"].includes(key)) return "GOLD";
    if (["SILVER", "XAGUSD", "XAG", "XAGUSDT"].includes(key)) return "Silver";
    if (["PLATINUM", "XPTUSD", "XPT", "XPTUSDT"].includes(key)) return "Platinum";
    return key;
  };

  const getLiveBidAskFromSocket = (symbol = "") => {
    if (isCommodityTradeSymbol(symbol)) {
      const ticker = getCommodityTicker(symbol);
      const ask = Number(ticker?.ask);
      const bid = Number(ticker?.bid);
      if (Number.isFinite(ask) && Number.isFinite(bid)) return { ask, bid };
      return null;
    }

    const key = String(symbol).replace(/[/_]/g, "").toUpperCase();
    const ticker = priceRef.current[key] || priceRef.current[symbol] || null;
    const ask = Number(ticker?.ask);
    const bid = Number(ticker?.bid);
    if (Number.isFinite(ask) && Number.isFinite(bid)) return { ask, bid };
    return null;
  };

  const handleRow = (record) => {
    return {
      onClick: () => {
        // setSelectedRow(record);
        setMobileDraw(true);
      },
    };
  };
  const getClosedPositions = async () => {
    try {
      const { data } = await Axios.post(
        "/ownTrade/getClosedPositions",
        {},
        {
          headers: {
            Authorization: localStorage.getItem("nzanzi"),
          },
        },
      );
      if (data?.success) {
        setClosedPositions(
          data?.result?.map((i) => {
            const pnl = (i?.closed_price - i?.price) * i?.quantity;
            return {
              ...i,
              close_time: formatedDateTime(i.close_time),
              open_time: formatedDateTime(i.open_time),
              status: "Closed",
              type: "future",
              side: i.side === "buy" ? "Buy" : "Sell",
              pnl:
                Number(pnl) >= 0 ? (
                  <span style={{ color: "#009A2C" }}>
                    {Number(pnl).toFixed(8)}
                  </span>
                ) : (
                  <span style={{ color: "red" }}>{Number(pnl).toFixed(8)}</span>
                ),
              stop_loss: i?.stop_loss ? Number(i?.stop_loss).toFixed(5) : "-",
              take_profit: i?.take_profit
                ? Number(i?.take_profit).toFixed(5)
                : "-",
            };
          }),
        );
      } else {
        message.error(data?.message);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (typeFilter === "future" && type === "close") {
      getClosedPositions();
    } else {
    }
  }, [typeFilter, type]);
  //remove chart id
  // Get existing saved pairs (if any)
  const existingPairs = JSON.parse(localStorage.getItem("chartPairs") || "[]");
  // const [closingId, setClosingId] = useState(null)

  const showModal = (val) => {
    setVal(val);
    setIsModalOpen(true);
  };
  const handleOk = () => {
    setIsModalOpen(false);
  };
  const handleCancel = () => {
    setEdit({});
    setSlTp(0);
    setPip(0);
    setIsModalOpen(false);
  };
  const [aggregate, setAggregate] = useState({
    id: "",
    symbol: "",
    side: "",
    quantity: 0,
    avgPrice: 0,
  });

  useEffect(() => {
    const tabs = JSON.parse(localStorage.getItem("tabs"));
    if (tabs && type === "pending" && openOrders?.length > 0) {
      const forexpair = tabs.find((d) => d.typ === "forex");
      if (!forexpair) return;

      const filteredTrades = openOrders.filter(
        (d) =>
          d?.symbol?.replace("/", "") === forexpair.title &&
          d.status === "Pending",
      );
      if (filteredTrades.length > 0) {
        const totalQuantity = filteredTrades.reduce(
          (sum, trade) => sum + Number(trade.quantity || 0),
          0,
        );
        const weightedPriceSum = filteredTrades.reduce(
          (sum, trade) =>
            sum + Number(trade.price || 0) * Number(trade.quantity || 0),
          0,
        );
        const avgPrice =
          totalQuantity > 0 ? weightedPriceSum / totalQuantity : 0;

        const side = filteredTrades[0]?.side || "";
        const symbol = filteredTrades[0]?.symbol || "";

        setAggregate({
          id:
            filteredTrades[0]?._id +
            filteredTrades[filteredTrades.length - 1]?._id,
          symbol,
          side,
          quantity: totalQuantity.toFixed(5),
          avgPrice: avgPrice.toFixed(5),
        });
      } else {
        setAggregate({
          id: "",
          symbol: "",
          side: "",
          quantity: 0,
          avgPrice: 0,
        });
      }
    }
  }, [activeKey, openOrders, type]);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 767) {
        setCollapsedHistory(true);
      }
    };
    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  //socket for position updates
  // useEffect(() => {
  //   socket.emit("getOpenOrders", {
  //     access_token: localStorage.getItem("nzanzi"),
  //   });
  //   socket.on("getOpenOrders", (data) => {
  //     getPositions();
  //   });
  // }, []);

  const updateTrade = async () => {
    try {
      const pipValue = edit?.symbol.includes("JPY") ? 0.001 : 0.00001;
      if (Number(pip) <= 0) {
        return message.error("Please enter a valid value");
      }
      const value = parseFloat((pipValue * pip).toFixed(5));
      const isBuy = edit?.side === "buy";
      const price = Number(edit?.price);
      const payload = {
        id: edit?._id,
        type: "update",
      };
      if (val !== 0) {
        if (isBuy) {
          payload.take_profit = Number(price + value).toFixed(5);
        } else {
          payload.take_profit = Number(price - value).toFixed(5);
        }
      } else {
        if (isBuy) {
          payload.stop_loss = Number(price - value).toFixed(5);
        } else {
          payload.stop_loss = Number(price + value).toFixed(5);
        }
      }

      if (
        Number(edit?.take_profit) === Number(payload.take_profit) ||
        Number(edit?.stop_loss) === Number(payload.stop_loss)
      ) {
        return message.error("Please enter a different value");
      }
      const updateEndpoint = isCommodityTradeSymbol(edit?.symbol)
        ? "/users/placeCommoditiesTrade"
        : "/users/placeForexTrade";

      const { data } = await Axios.post(updateEndpoint, payload, {
        headers: { Authorization: localStorage.getItem("nzanzi") },
      });

      if (data?.success) {
        message.success(data.message);
        getTradeHistory();
        handleCancel();
        setTriggerForexOrders((pre) => !pre);
      } else {
        message.error(data.message);
      }
    } catch (e) {
      console.error(e);
      message.error(e?.response?.data?.message || "Something went wrong");
    }
  };

  const updateFutureTrade = async () => {
    try {
      const price = Number(futureSlTp).toFixed(edit?.pricePrecision);

      if (price < 0) {
        return message.error("Please enter a valid value");
      }

      const payload = {
        position_id: edit?._id,
      };
      if (val !== 0) {
        payload.takeProfit = price;
      } else {
        payload.stopLoss = price;
      }

      const { data } = await Axios.post(
        "/ownTrade/updateFuturePosition",
        payload,
        {
          headers: { Authorization: localStorage.getItem("nzanzi") },
        },
      );

      if (data?.success) {
        message.success(data.message);
        getPositions();
        handleCancel();
      } else {
        message.error(data.message);
      }
      setFutureSlTp(0);
      setFutureSlTpMoney(0);
    } catch (e) {
      console.error(e);
      message.error(e?.response?.data?.message || "Something went wrong");
    }
  };

  const handlePipChange = (value) => {
    try {
      if (isNaN(value)) return;
      const quantity = Number(edit?.quantity);
      const symbol = edit?.symbol;
      const pipSize = symbol.includes("JPY") ? 0.001 : 0.00001;
      const units = quantity * 100000;
      const price = Number(edit?.price);
      let pipValueUSD;
      // if (symbol.endsWith("USD")) {
      //     pipValueUSD = pipSize * units;
      // } else {
      pipValueUSD = (pipSize * units) / price;
      // }
      setPip(value);
      const pips = Number(value) * pipValueUSD;
      setSlTp(parseFloat(pips.toFixed(5)));
    } catch (error) {
      console.log(error);
    }
  };
  const handleSlTpChange = (value) => {
    try {
      if (isNaN(value)) return;
      const quantity = Number(edit?.quantity);
      const symbol = edit?.symbol;
      const pipSize = symbol.includes("JPY") ? 0.001 : 0.00001;
      const units = quantity * 100000;
      const price = Number(edit?.price);
      let pipValueUSD;
      // if (symbol.endsWith("JPY")) {
      //   pipValueUSD = pipSize * units;
      // } else {
      pipValueUSD = (pipSize * units) / price;
      // }
      setSlTp(value);
      const pipCount = Number(value) / pipValueUSD;
      setPip(parseFloat(pipCount.toFixed(0)));
    } catch (error) {
      console.log(error);
    }
  };

  const handleFutureTpSlChange = (value) => {
    console.log(value);
    try {
      const newVal = Number(value);
      const isBuy = edit?.direction == "buy";
      const qty = Number(edit?.lot_size);
      const price = Number(edit?.entry_price);
      const precision = Number(edit?.pricePrecision);
      setFutureSlTp(value);

      if (val == 0) {
        const newLoss = isBuy ? (price - newVal) * qty : (newVal - price) * qty;
        setFutureSlTpMoney(
          Number(newLoss) > 0 ? Number(newLoss)?.toFixed(precision) : 0,
        );
      } else {
        const newProfit = isBuy
          ? (newVal - price) * qty
          : (price - newVal) * qty;
        setFutureSlTpMoney(
          Number(newProfit) > 0 ? Number(newProfit)?.toFixed(precision) : 0,
        );
      }
    } catch (error) {
      console.log(error, "errorpip");
    }
  };

  const handleFutureTpSlMoneyChange = (value) => {
    try {
      const newVal = Number(value);
      const precision = edit?.pricePrecision;
      const isBuy = edit?.direction == "buy";
      const qty = Number(edit?.lot_size);
      const price = Number(edit?.entry_price);
      const pnl = Number(newVal / qty);
      setFutureSlTpMoney(value);

      if (val == 0) {
        setFutureSlTp(
          isBuy
            ? (price - pnl)?.toFixed(precision)
            : (price + pnl)?.toFixed(precision),
        );
      } else {
        setFutureSlTp(
          isBuy
            ? (price + pnl)?.toFixed(precision)
            : (price - pnl)?.toFixed(precision),
        );
      }
    } catch (error) {
      console.log(error, "errorpip");
    }
  };

  //   BINARY HISTORY
  const baseColumns = [
    { title: "Pair", dataIndex: "pair" },
    { title: "Type", dataIndex: "type", align: "center" },
    {
      title: "Start Time",
      dataIndex: "startTime",
      align: "center",
    },
    {
      title: "End Time",
      dataIndex: "endTime",
      align: "center",
    },
    {
      title: "Start Price",
      dataIndex: "start_price",
      align: "center",
    },
    {
      title: "End Price",
      dataIndex: "end_price",
      align: "center",
    },
    {
      title: "Betting Amount",
      dataIndex: "betting_amount",
      align: "center",
    },
    {
      title: "Received Amount",
      dataIndex: "received_amount",
      align: "center",
    },
    {
      title: "Result",
      dataIndex: "result",
      align: "center",
    },
    // {
    //     title: "Close", dataIndex: "close", align: "center"
    // },
  ];

  const columns = baseColumns;

  //   ORDER HISTORY
  const baseForexColumns = [
    { title: "Pair", dataIndex: "pair" },
    { title: "Side", dataIndex: "side", align: "center" },

    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "center",
    },
    {
      title: "Margin",
      dataIndex: "margin",
      align: "center",
    },
    {
      title: "Open Price",
      dataIndex: "price",
      align: "center",
    },
    // {
    //     title: "Current Price",
    //     dataIndex: "current_price",
    //     align: "center",
    // },
    {
      title: "Closed Price",
      dataIndex: "closed_price",
      align: "center",
    },
    {
      title: "P&L",
      dataIndex: "pnl",
      align: "center",
    },
    {
      title: "TP",
      dataIndex: "take_profit",
      align: "center",
    },
    {
      title: "SL",
      dataIndex: "stop_loss",
      align: "center",
    },
    {
      title: "Open Time",
      dataIndex: "open_time",
      align: "center",
    },
    {
      title: "Close Time",
      dataIndex: "close_time",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
    },
    // {
    //     title: "Close",
    //     dataIndex: "close",
    //     align: "center",
    // },
    // {
    //     title: "Action",
    //     dataIndex: "action",
    //     align: "center",
    // },
  ];

  const forexColumns = baseForexColumns;

  //   OPEN
  const baseforexColumns2 = [
    { title: "Pair", dataIndex: "pair" },
    { title: "Side", dataIndex: "side", align: "center" },

    {
      title: "Quantity",
      dataIndex: "quantity",
      align: "center",
    },
    {
      title: "Margin",
      dataIndex: "margin",
      align: "center",
    },
    {
      title: "Open Price",
      dataIndex: "price",
      align: "center",
    },
    {
      title: "Current Price",
      dataIndex: "current_price",
      align: "center",
    },
    // {
    //     title: "Closed Price",
    //     dataIndex: "closed_price",
    //     align: "center",
    // },
    {
      title: "P&L",
      dataIndex: "pnl",
      align: "center",
    },
    {
      title: "TP",
      dataIndex: "take_profit",
      align: "center",
    },
    {
      title: "SL",
      dataIndex: "stop_loss",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
    },
    {
      title: "Close",
      dataIndex: "close",
      align: "center",
      fixed: "right",
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
      fixed: "right",
    },
  ];

  const baseFutureColumn = [
    { title: "Pair", dataIndex: "symbol" },
    { title: "Side", dataIndex: "direction", align: "center" },

    {
      title: "Quantity",
      dataIndex: "lot_size",
      align: "center",
    },
    {
      title: "Open Price",
      dataIndex: "entry_price",
      align: "center",
    },
    {
      title: "Current Price",
      dataIndex: "current_price",
      align: "center",
    },
    // {
    //     title: "Closed Price",
    //     dataIndex: "closed_price",
    //     align: "center",
    // },
    {
      title: "Margin",
      dataIndex: "margin",
      align: "center",
    },
    {
      title: "P&L",
      dataIndex: "unrealized_pnl",
      align: "center",
    },
    {
      title: "TP",
      dataIndex: "take_profit",
      align: "center",
    },
    {
      title: "SL",
      dataIndex: "stop_loss",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "status",
      align: "center",
    },
    {
      title: "Close",
      dataIndex: "close",
      align: "center",
    },
    {
      title: "Action",
      dataIndex: "action",
      align: "center",
    },
  ];

  const forexColumns2 = baseforexColumns2;

  const [edit, setEdit] = useState({});

  const items = (records) => [
    {
      label: (
        <div
          onClick={() => {
            showModal(0);
            setEdit(records);
            if (records?.isFuture) {
              console.log(records, "Future records");
              setFutureSlTp(
                Number(records?.stop_loss)?.toFixed(records?.pricePrecision),
              );
              setFutureSlTpMoney(Number(records?.tradeLoss));
            }
          }}
        >
          Stop loss
        </div>
      ),
      key: "0",
    },
    {
      label: (
        <div
          onClick={() => {
            showModal(1);
            setEdit(records);
            if (records?.isFuture) {
              setFutureSlTp(
                Number(records?.take_profit)?.toFixed(records?.pricePrecision),
              );
              setFutureSlTpMoney(Number(records?.tradeProfit));
            }
          }}
        >
          Take Profit
        </div>
      ),
      key: "1",
    },
  ];

  const [data, setData] = useState([]);
  const [posData, setPosData] = useState([]);
  // const subscribePair = () => {
  //     try {
  //         // const ws = new WebSocket("wss://trade.marginfxtrade.com/ws/");
  //         const ws = new WebSocket(`wss://ws.twelvedata.com/v1/quotes/price?apikey=${consts.apikey}`);
  //         ws_ref.current = ws;
  //         ws.onopen = () => {
  //             const symbols = tradeHistory.map((trade) => trade.symbol);
  //             ws.send(
  //                 JSON.stringify({
  //                     action: "subscribe",
  //                     params: {
  //                         symbols: symbols.slice(0, 3) + "/" + symbols.slice(3),
  //                     }

  //                 })
  //             );
  //             console.log("Subscribed to:", symbols.join(","));
  //         };

  //         ws.onmessage = function (event) {
  //             if (typeof event.data === "string") {
  //                 try {
  //                     let parsedData;
  //                     try {
  //                         parsedData = JSON.parse(event.data);
  //                     } catch (e) {
  //                         return;
  //                         // parsedData = event.data;
  //                     }
  //                     // console.log("Received message:", parsedData);
  //                     // const parsedData = JSON.parse(event.data);

  //                     const spreads = parsedData?.symbol?.includes("JPY") ? 0.001 : 0.00001;;  // 1.5 pips
  //                     const bids = parsedData?.price - spreads / 2;
  //                     const asks = parsedData?.price + spreads / 2;
  //                     // log
  //                     const sell = bids.toFixed(5);
  //                     const buy = asks.toFixed(5);

  //                     const symbolFormatted = parsedData?.symbol.trim().toUpperCase();

  //                     const symbol = symbolFormatted;
  //                     const bid = sell;
  //                     const ask = buy;

  //                     console.log(ask, bid, symbol, "alldata");

  //                     if (!symbol || !bid || !ask) return;
  //                     const pairs = tradeHistory.map((trade) => trade.symbol);
  //                     console.log(pairs, !pairs.includes(symbol.replace("/", "")), symbol, "VJpairs");

  //                     // if (!pairs.includes(symbol)) return;
  //                     console.log(priceRef, symbol, "hi");

  //                     console.log(bid, ask, "newprice");

  //                     priceRef.current[symbol] = {
  //                         bid: bid,
  //                         ask: ask,
  //                     };

  //                     console.log(symbol, symbolFormatted, typeof (bid), ask, `.sell-${symbolFormatted}`, "symbolax");

  //                     $(`.current_price-${symbolFormatted.replace("/", "").trim().toUpperCase()}`).html(
  //                         `<span>${Number(ask).toFixed(5)}</span>`
  //                     );

  //                     $(`.closed_price-${symbolFormatted.replace("/", "").trim().toUpperCase()}`).html(
  //                         `<span>${Number(bid).toFixed(5)}</span>`
  //                     );
  //                     $(`.sell-${symbolFormatted.replace("/", "").trim().toUpperCase()}`).html(
  //                         `<span class=${Number(bid).toFixed(2) > 0 ? "tr-green" : "tr-red"
  //                         } > ${Number(bid).toFixed(5)}</span>`
  //                     );
  //                     $(`.buy-${symbolFormatted.replace("/", "").trim().toUpperCase()}`).html(
  //                         `<span class=${Number(ask).toFixed(2) > 0 ? "tr-green" : "tr-red"
  //                         } > ${Number(ask).toFixed(5)}</span>`
  //                     );
  //                     tradeHistoryRef?.current?.forEach((trade) => {
  //                         if (
  //                             trade.status === "Pending" &&
  //                             (type === "pending" || trade.status === "close") &&
  //                             trade.symbol === symbol
  //                         ) {
  //                             console.log(bid, ask, "vijay123");

  //                             const pnl = calculatePNL(
  //                                 Number(trade.price),
  //                                 trade.side,
  //                                 trade.symbol,
  //                                 Number(trade.quantity * 100000),
  //                                 bid,
  //                                 ask
  //                             );
  //                             console.log(pnl, "vijay123");

  //                             $(`.pnl-${trade._id}`).html(
  //                                 `<span style="color:${pnl >= 0 ? "#009A2C" : "red"
  //                                 }">${parseFloat(pnl.toFixed(5))}</span>`
  //                             );
  //                         }
  //                     });
  //                 } catch (error) { }
  //             } else {
  //                 console.log("Received non-string message:");
  //             }
  //         };
  //         ws.onerror = (error) => console.error("❌ Forex WS error", error);
  //         ws.onclose = () => {
  //             ws_ref.current = null;
  //             setTimeout(() => {
  //                 subscribePair();
  //             }, 3000);
  //             console.log("❌ Forex WS disconnected");
  //         };
  //     } catch (error) {
  //         console.error("WebSocket error:", error);
  //     }
  // };

  // useEffect(() => {
  //     if (type === "close" || type === "pending") {
  //         tradeHistoryRef.current = tradeHistory;
  //         subscribePair();
  //     }
  //     return () => {
  //         if (ws_ref.current) {
  //             try {
  //                 const symbols = tradeHistory.map((trade) => trade.symbol);
  //                 ws_ref.current.send(
  //                     JSON.stringify({
  //                         action: "unsubscribe",
  //                         params: {
  //                             symbols: symbols.slice(0, 3) + "/" + symbols.slice(3),
  //                         }

  //                     })
  //                 );
  //                 console.log("Unsubscribed from Forex WS in Tabpane:");
  //             } catch (e) { }
  //             tradeHistoryRef.current = [];
  //             ws_ref.current.close();
  //         }
  //         if (resetTimer) {
  //             clearTimeout(resetTimer);
  //         }
  //     };
  // }, [data, type]);

  const formatedDateTime = (date) => {
    const dateObj = new Date(date);
    const formattedDate = dateObj.toLocaleDateString("en-US", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
    const formattedTime = dateObj.toLocaleTimeString("en-US", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
    return `${formattedDate} ${formattedTime}`;
  };

  const formatForexTradeRow = (trade) => {
    const current = trade?.side === "buy" ? "sell" : "buy";

    return {
      pair: trade?.symbol ? (
        <div className="display-1">{trade.symbol}</div>
      ) : (
        "-"
      ),
      side: trade?.side === "buy" ? "Buy" : "Sell",
      quantity: trade?.quantity ? Number(trade.quantity).toFixed(3) : "-",
      margin: trade?.margin ? Number(trade.margin).toFixed(3) : "-",
      price: trade?.price ? Number(trade.price).toFixed(5) : "-",
      current_price:
        trade?.status === "Pending" ? (
          <span
            className={`${current + "-" + getSocketDomSymbol(trade?.symbol)
              }`}
          >
            -
          </span>
        ) : (
          "-"
        ),
      closed_price: trade?.closed_price ? (
        <span
          className={`closed_price-${trade?.symbol
            .replace("/", "")
            .toUpperCase()}`}
        >
          {Number(trade.closed_price).toFixed(5)}
        </span>
      ) : (
        "-"
      ),
      pnl:
        trade?.status === "Pending" ? (
          <span className={`pnl-${trade?._id}`}>-</span>
        ) : Number(trade?.profit) >= 0 ? (
          <span style={{ color: "#009A2C" }}>
            {Number(trade?.profit).toFixed(2)}
          </span>
        ) : (
          <span style={{ color: "red" }}>
            {Number(trade?.profit).toFixed(2)}
          </span>
        ),
      stop_loss: trade?.stop_loss ? Number(trade.stop_loss).toFixed(5) : "-",
      take_profit: trade?.take_profit
        ? Number(trade.take_profit).toFixed(5)
        : "-",
      status: trade?.status === "Pending" ? "Opened" : "Closed",
      open_time: trade?.createdAt ? formatedDateTime(trade.createdAt) : "-",
      close_time: trade?.closed_at ? formatedDateTime(trade.closed_at) : "-",
      action:
        trade?.status === "Pending" ? (
          <Dropdown menu={{ items: items(trade) }} trigger={["click"]}>
            <a onClick={(e) => e.preventDefault()}>
              <Space>
                Edit
                <EditOutlined />
              </Space>
            </a>
          </Dropdown>
        ) : (
          "-"
        ),
      close:
        trade?.status === "Pending" ? (
          <Popconfirm
            title="Close the trade"
            description="Are you sure to close this trade?"
            onConfirm={() => { }}
            okText="Yes"
            placement="left"
            cancelText="No"
          >
            <Button variant="solid" color="danger" disabled={load}>
              Close
            </Button>
          </Popconfirm>
        ) : (
          "-"
        ),
    };
  };
  useEffect(() => {
    let interval;
    if (tradeHistory.length > 0 && (type === "pending" || type === "close")) {
      try {
        interval = setInterval(() => {
          if (type === "pending" && aggregate.quantity) {
            const liveAggregate = getLiveBidAskFromSocket(aggregate?.symbol);
            if (!liveAggregate) return;
            const { ask, bid } = liveAggregate;
            if (!ask || !bid) return;
            const pnl = calculatePNL(
              Number(aggregate?.avgPrice),
              aggregate?.side,
              aggregate?.symbol,
              Number(aggregate?.quantity * 100000),
              bid,
              ask,
            );
            $(`.pnl-${aggregate?.id}`).html(
              `<span style="color:${pnl >= 0 ? "#009A2C" : "red"}">${parseFloat(
                pnl.toFixed(2),
              )}</span>`,
            );
          }
          tradeHistory.map((trade) => {
            if (trade.status === "Pending") {
              const liveQuote = getLiveBidAskFromSocket(trade?.symbol);
              if (!liveQuote) return;
              const { ask, bid } = liveQuote;
              if (!ask || !bid) return;
              const pnl = calculatePNL(
                Number(trade.price),
                trade.side,
                trade.symbol,
                Number(trade.quantity * 100000),
                bid,
                ask,
              );
              $(`.pnl-${trade._id}`).html(
                `<span style="color:${pnl >= 0 ? "#009A2C" : "red"
                }">${parseFloat(pnl.toFixed(2))}</span>`,
              );
            }
          });
        }, 500);
      } catch (e) {
        console.log(e, "ERROR");
      }
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [tradeHistory, aggregate]);

  useEffect(() => {
    let interval;
    if (positions?.length > 0) {
      try {
        interval = setInterval(() => {
          positions.map((trade) => {
            if (
              trade.status === "init" ||
              trade.status === "partially filled"
            ) {
              const symbol = trade.symbol.replace("_", "");
              const ticker = getFutureTicker(symbol);
              if (!ticker) return;

              const pnl = calculateBinancePNL(
                Number(trade.entry_price),
                trade.direction,
                trade.positionSide,
                symbol,
                Number(trade.lot_size),
              );

              const markPrice = Number(ticker?.markPrice).toFixed(
                trade.pricePrecision,
              );

              const margin = Number(
                (markPrice * Number(trade.lot_size)) / trade.leverage,
              )?.toFixed(trade.pricePrecision);

              $(`.pnl-${trade._id}`).html(
                `<span style="color:${pnl >= 0 ? "#009A2C" : "red"
                }">${pnl?.toFixed(trade?.pricePrecision)}</span>`,
              );

              $(`.current-${symbol}`).html(`<span >${markPrice}</span>`);

              $(`.margin-${trade._id}`).html(`<span >${margin}</span>`);
            }
          });
        }, 500);
      } catch (e) {
        console.log(e, "ERROR");
      }
    }
    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [positions]);

  const openNotification = (trade) => {
    const parent = document.querySelector(".not-cls"); // 👈 your DOM parent selector
    console.log(trade, "trade");

    notification.open({
      message: null,
      description: (
        <div className="card">
          <div className="img">
            <img
              src={tabs.find((i) => i.title === trade?.symbol)?.imgSrc}
              alt="icon"
            />
          </div>
          <div className="textBox">
            <div className="textContent">
              <p className="h1">{trade?.symbol}</p>
              <p className="p">Qty: {trade?.quantity}</p>
            </div>
            {/* <div className="display-6">
              <p className="p">
                TP/SL: {trade?.tp} / {trade?.sl}
              </p>
            </div> */}

            <p className="p plc">
              Order Closed <CheckCircleFilled style={{ color: "green" }} />
            </p>
          </div>
        </div>
      ),
      className: "custom-ant-notification",
      icon: null,
      duration: 6,
      closeIcon: true,
      placement: "top",
      getContainer: () => parent || document.body, // <-- renders inside your DOM parent
    });
  };
  const calculatePNL = (price, side, symbol, qty, bidPrice, askPrice) => {
    const entryPrice = side === "buy" ? Number(price) : Number(askPrice);
    const exitPrice = side === "buy" ? Number(bidPrice) : Number(price);
    const pipSize = symbol.includes("JPY") ? 0.01 : 0.0001;
    const size = qty;
    const profit = exitPrice - entryPrice;
    const pipGained = profit / pipSize;
    let pipValue;
    const prcVal = side === "buy" ? exitPrice : entryPrice;
    pipValue = size * pipSize;
    const pnl = (pipGained * pipValue) / prcVal;
    return Number(pnl);
  };

  const calculateBinancePNL = (posPrice, side, positionSide, symbol, qty) => {
    let pnl = (getFutureTicker(symbol)?.markPrice - posPrice) * qty;
    if (positionSide == "short") pnl = pnl * -1;
    return Number(pnl);
  };

  const playSucccessSound = () => {
    const audio = new Audio(success);
    audio.play().catch(() => { });
  };

  //playsound success sound
  const playLossSound = () => {
    const audio = new Audio(lose);
    audio.play().catch(() => { });
  };
  const [recentlyClosed, setRecentlyClosed] = useState(new Set());
  const closeTrade = async (trade) => {
    const existingPairs = JSON.parse(
      localStorage.getItem("chartPairs") || "[]",
    );

    const match = existingPairs.find(
      (pair) => pair.currencyPair.toLowerCase() === trade?.symbol.toLowerCase(),
    );

    try {
      setLoad(true);
      const liveQuote = getLiveBidAskFromSocket(trade?.symbol);
      const fallbackPrice =
        trade.side === "buy"
          ? Number(trade.price) + Number(0.0005)
          : Number(trade.price) - Number(0.0005);
      const price = liveQuote
        ? trade.side === "buy"
          ? Number(liveQuote?.bid)
          : Number(liveQuote?.ask)
        : fallbackPrice;

      const bidForPnl = liveQuote ? Number(liveQuote?.bid) : Number(trade.price - 0.0005);
      const askForPnl = liveQuote ? Number(liveQuote?.ask) : Number(trade.price + 0.0005);

      const pnl = calculatePNL(
        Number(trade.price),
        trade.side,
        trade.symbol,
        Number(trade.quantity * 100000),
        bidForPnl,
        askForPnl,
      );
      const payload = {
        id: trade._id,
        type: "close",
        closed_price: price,
        pnl: Number(pnl.toFixed(5)),
      };
      const closeEndpoint = isCommodityTradeSymbol(trade?.symbol)
        ? "/users/placeCommoditiesTrade"
        : "/users/placeForexTrade";

      const { data } = await Axios.post(closeEndpoint, payload, {
        headers: {
          Authorization: localStorage.getItem("nzanzi"),
        },
      });
      if (data?.success) {
        // message.success("Trade closed successfully");
        openNotification(trade);

        const tradePNL = Number(data?.pnl || payload.pnl);
        if (tradePNL > 0) playSucccessSound();
        else playLossSound();

        setRecentlyClosed((prev) => new Set([...prev, trade._id]));
        getWallet();
        getTradeHistory();
        setTriggerForexOrders((pre) => !pre);
        if (match?.chartId) {
          handleRemoveAllLines(match?.chartId);
        }
        // handleRemoveAllLines(closingId.chartId)
        // setClosingId(existingPairs.find((pair) => pair.currencyPair.toLowerCase() === trade?.symbol.toLowerCase()))
      } else {
        message.error(data?.message || "Failed to close trade");
      }
    } catch (err) {
      console.error(err, "error closing trade");
      message.error(
        err?.response?.data?.message ||
        "An error occurred while closing the trade",
      );
    } finally {
      setLoad(false);
    }
  };

  const closeFuturePosition = async (trade) => {
    const existingPairs = JSON.parse(
      localStorage.getItem("chartPairs") || "[]",
    );

    const match = existingPairs.find(
      (pair) =>
        pair.currencyPair.toLowerCase() ===
        trade?.symbol?.split("_")?.join("").toLowerCase(),
    );

    try {
      setLoad(true);
      const pnl = calculateBinancePNL(
        Number(trade.price),
        trade.side,
        trade.positionSide,
        trade.symbol,
        Number(trade.lot_size),
      );
      const payload = {
        position_id: trade._id,
      };
      const { data } = await Axios.post("/ownTrade/closePosition", payload, {
        headers: {
          Authorization: localStorage.getItem("nzanzi"),
        },
      });
      if (data?.success) {
        message.success("Position closed successfully");
        const tradePNL = Number(pnl);
        if (tradePNL > 0) playSucccessSound();
        else playLossSound();

        setRecentlyClosed((prev) => new Set([...prev, trade._id]));
        getWallet();
        getPositions();
        console.log(match?.chartId, "match?.chatyua");
        if (match?.chartId) {
          handleFutureRemoveAllLines(match?.chartId);
        }
      } else {
        message.error(data?.message || "Failed to close position");
      }
    } catch (err) {
      console.error(err, "error closing position");
      message.error(
        err?.response?.data?.message ||
        "An error occurred while closing the position",
      );
    } finally {
      setLoad(false);
    }
  };
  const [pending, setPending] = useState([]);
  // const checkCloseTrade = async () => {
  //   try {
  //     if (pending.length > 0) {
  //       const ids = pending.map((i) => i?._id);

  //       const { data } = await Axios.post(
  //         "/users/getTradeHistory",
  //         { type: "close" },
  //         {
  //           headers: {
  //             Authorization: localStorage.getItem("nzanzi"),
  //           },
  //         }
  //       );

  //       if (data?.success) {
  //         const closedTrades = data.result.filter(
  //           (t) => ids.includes(t?._id) && t.status === "Closed"
  //         );
  //         const existingPairs = JSON.parse(
  //           localStorage.getItem("chartPairs") || "[]"
  //         );
  //         console.log(closedTrades, "closedTrades");

  //         const match = existingPairs.find(
  //           (pair) =>
  //             pair.currencyPair.toLowerCase() ===
  //             closedTrades[0]?.symbol.toLowerCase()
  //         );

  //         for (const trade of closedTrades) {
  //           if (!recentlyClosed.has(trade._id)) {
  //             if (Number(trade?.pnl) > 0) playSucccessSound();
  //             else playLossSound();

  //             setRecentlyClosed((prev) => new Set([...prev, trade._id]));
  //           }
  //           if (match?.chartId) {
  //             handleRemoveAllLines(match?.chartId);
  //           }
  //           // handleRemovePlotLines(
  //           //     ["tp-line", "sl-line", "bet-line"],
  //           //     trade.symbol.replace("/", "").toLowerCase()
  //           // );
  //         }
  //       }

  //       const openTrades = tradeHistory.filter((i) => i?.status === "Pending");
  //       setPending(openTrades);
  //     } else if (type === "pending" || type === "close") {
  //       const openTrades = tradeHistory.filter((i) => i?.status === "Pending");
  //       setPending(openTrades);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };

  // useEffect(() => {
  //   checkCloseTrade();
  // }, [tradeHistory]);
  console.log(tradeHistory, "tradeHistory", type, "tradeHistory type");
  useEffect(() => {
    console.log(
      openOrders,
      tradeHistory.length,
      openOrders.length,
      "tradeHistory Open orders",
    );
    if (tradeHistory.length > 0 && type !== "pending") {
      if (type === "binary") {
        const formatedRow = [];
        for (let i = 0; i < tradeHistory.length; i++) {
          const obj = {};
          obj.pair = tradeHistory[i]?.pair ? (
            <div className="display-1">
              <img
                width="25"
                height="25"
                src={tradeHistory[i]?.url}
                alt="gold-bars"
              />
              {tradeHistory[i]?.pair}
            </div>
          ) : (
            "-"
          );
          obj.type = tradeHistory[i]?.direction === "high" ? "High" : "Low";
          obj.startTime = formatedDateTime(tradeHistory[i]?.startTime);
          obj.endTime = formatedDateTime(tradeHistory[i]?.endTime);
          obj.start_price = tradeHistory[i]?.start_price;
          obj.end_price = tradeHistory[i]?.end_price;
          obj.betting_amount = tradeHistory[i]?.quantity;
          obj.received_amount = tradeHistory[i]?.result ? (
            <span style={{ color: "#009A2C" }}>
              {" "}
              + {tradeHistory[i]?.received_amount}
            </span>
          ) : (
            <span style={{ color: "red" }}>
              {" "}
              - {tradeHistory[i]?.received_amount}
            </span>
          );
          obj.result = tradeHistory[i]?.result ? (
            <span style={{ color: "#009A2C" }}>Win</span>
          ) : (
            <span style={{ color: "red" }}>Loss</span>
          );
          obj.close = (
            <Popconfirm
              title="Delete the task"
              description="Are you sure to delete this task?"
              // onConfirm={confirm}
              // onCancel={cancel}
              okText="Yes"
              placement="left"
              cancelText="No"
            >
              <Button variant="solid" color="danger" disabled={load}>
                Close
              </Button>
            </Popconfirm>
          );
          formatedRow.push(obj);
        }
        setData(formatedRow);
      } else if (type === "close") {
        const formatedRow = [];

        for (let i = 0; i < tradeHistory.length; i++) {
          if (tradeHistory[i]?.status === "Pending" && type === "close") {
            continue;
          }
          if (!shouldIncludeTradeByOrderHistoryFilter(tradeHistory[i])) {
            continue;
          }
          const obj = {};
          const current = tradeHistory[i]?.side === "buy" ? "sell" : "buy";

          obj.pair = tradeHistory[i]?.symbol ? (
            <div className="display-1">
              {/* <img width="25" height="25" alt="gold-bars" /> */}
              {tradeHistory[i]?.symbol}
            </div>
          ) : (
            "-"
          );
          obj.side = tradeHistory[i]?.side === "buy" ? "Buy" : "Sell";
          obj.quantity = tradeHistory[i]?.quantity
            ? Number(tradeHistory[i]?.quantity).toFixed(3)
            : "-";
          obj.margin = tradeHistory[i]?.margin
            ? Number(tradeHistory[i]?.margin).toFixed(3)
            : "-";
          obj.price = tradeHistory[i]?.price
            ? Number(tradeHistory[i]?.price).toFixed(5)
            : "-";
          obj.current_price =
            tradeHistory[i]?.status === "Pending" ? (
              <span
                className={`${current +
                  "-" +
                  getSocketDomSymbol(tradeHistory[i]?.symbol)
                  }`}
              >
                -
              </span>
            ) : (
              "-"
            );
          obj.closed_price = tradeHistory[i]?.closed_price ? (
            <span
              className={`closed_price-${tradeHistory[i]?.symbol
                .replace("/", "")
                .toUpperCase()}`}
            >
              {Number(tradeHistory[i]?.closed_price).toFixed(5)}
            </span>
          ) : (
            "-"
          );
          obj.pnl =
            tradeHistory[i]?.status === "Pending" ? (
              <span className={`pnl-${tradeHistory[i]?._id}`}>-</span>
            ) : Number(tradeHistory[i]?.profit) >= 0 ? (
              <span style={{ color: "#009A2C" }}>
                {Number(tradeHistory[i]?.profit).toFixed(2)}
              </span>
            ) : (
              <span style={{ color: "red" }}>
                {Number(tradeHistory[i]?.profit).toFixed(2)}
              </span>
            );
          obj.stop_loss = tradeHistory[i]?.stop_loss
            ? Number(tradeHistory[i]?.stop_loss).toFixed(5)
            : "-";
          obj.take_profit = tradeHistory[i]?.take_profit
            ? Number(tradeHistory[i]?.take_profit).toFixed(5)
            : "-";
          obj.status =
            tradeHistory[i]?.status === "Pending" ? "Opened" : "Closed";
          obj.open_time = tradeHistory[i]?.createdAt
            ? formatedDateTime(tradeHistory[i]?.createdAt)
            : "-";
          obj.close_time = tradeHistory[i]?.closed_at
            ? formatedDateTime(tradeHistory[i]?.closed_at)
            : "-";
          obj.action =
            tradeHistory[i]?.status === "Pending" ? (
              <Dropdown
                menu={{ items: items(tradeHistory[i]) }}
                trigger={["click"]}
              >
                <a onClick={(e) => e.preventDefault()}>
                  <Space>
                    Edit
                    <EditOutlined />
                  </Space>
                </a>
              </Dropdown>
            ) : (
              "-"
            );

          obj.close =
            tradeHistory[i]?.status === "Pending" ? (
              <Popconfirm
                title="Close the trade"
                description="Are you sure to close this trade?"
                onConfirm={() => {
                  closeTrade(tradeHistory[i]);
                }}
                // onCancel={cancel}
                okText="Yes"
                placement="left"
                cancelText="No"
              >
                <Button variant="solid" color="danger" disabled={load}>
                  Close
                </Button>
              </Popconfirm>
            ) : (
              "-"
            );
          formatedRow.push(obj);
        }
        setData(formatedRow);
      }
    } else if (type === "pending") {
      const formatedRow = [];

      for (let i = 0; i < tradeHistory.length; i++) {
        if (tradeHistory[i]?.status !== "Pending" && type === "pending") {
          continue;
        }
        if (!shouldIncludeTradeByOpenOrderFilter(tradeHistory[i])) {
          continue;
        }
        const obj = {};
        const current = tradeHistory[i]?.side === "buy" ? "sell" : "buy";

        obj.pair = tradeHistory[i]?.symbol ? (
          <div className="display-1">
            {/* <img width="25" height="25" alt="gold-bars" /> */}
            {tradeHistory[i]?.symbol}
          </div>
        ) : (
          "-"
        );
        obj.side = tradeHistory[i]?.side === "buy" ? "Buy" : "Sell";
        obj.quantity = tradeHistory[i]?.quantity
          ? Number(tradeHistory[i]?.quantity).toFixed(3)
          : "-";
        obj.margin = tradeHistory[i]?.margin
          ? Number(tradeHistory[i]?.margin).toFixed(3)
          : "-";
        obj.price = tradeHistory[i]?.price
          ? Number(tradeHistory[i]?.price).toFixed(5)
          : "-";
        obj.current_price =
          tradeHistory[i]?.status === "Pending" ? (
            <span
              className={`${current +
                "-" +
                getSocketDomSymbol(tradeHistory[i]?.symbol)
                }`}
            >
              -
            </span>
          ) : (
            "-"
          );
        obj.closed_price = tradeHistory[i]?.closed_price ? (
          <span
            className={`closed_price-${tradeHistory[i]?.symbol
              .replace("/", "")
              .toUpperCase()}`}
          >
            {Number(tradeHistory[i]?.closed_price).toFixed(5)}
          </span>
        ) : (
          "-"
        );
        obj.pnl =
          tradeHistory[i]?.status === "Pending" ? (
            <span className={`pnl-${tradeHistory[i]?._id}`}>-</span>
          ) : Number(tradeHistory[i]?.profit) >= 0 ? (
            <span style={{ color: "#009A2C" }}>
              {Number(tradeHistory[i]?.profit).toFixed(2)}
            </span>
          ) : (
            <span style={{ color: "red" }}>
              {Number(tradeHistory[i]?.profit).toFixed(2)}
            </span>
          );
        obj.stop_loss = tradeHistory[i]?.stop_loss
          ? Number(tradeHistory[i]?.stop_loss).toFixed(5)
          : "-";
        obj.take_profit = tradeHistory[i]?.take_profit
          ? Number(tradeHistory[i]?.take_profit).toFixed(5)
          : "-";
        obj.status =
          tradeHistory[i]?.status === "Pending" ? "Opened" : "Closed";
        obj.open_time = tradeHistory[i]?.createdAt
          ? formatedDateTime(tradeHistory[i]?.createdAt)
          : "-";
        obj.close_time = tradeHistory[i]?.closed_at
          ? formatedDateTime(tradeHistory[i]?.closed_at)
          : "-";
        obj.action =
          tradeHistory[i]?.status === "Pending" ? (
            <Dropdown
              menu={{ items: items(tradeHistory[i]) }}
              trigger={["click"]}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  Edit
                  <EditOutlined />
                </Space>
              </a>
            </Dropdown>
          ) : (
            "-"
          );

        obj.close =
          tradeHistory[i]?.status === "Pending" ? (
            <Popconfirm
              title="Close the trade"
              description="Are you sure to close this trade?"
              onConfirm={() => {
                closeTrade(tradeHistory[i]);
              }}
              // onCancel={cancel}
              okText="Yes"
              placement="left"
              cancelText="No"
            >
              <Button variant="solid" color="danger" disabled={load}>
                Close
              </Button>
            </Popconfirm>
          ) : (
            "-"
          );
        formatedRow.push(obj);
      }

      setData(formatedRow);
    } else if (openOrders?.length > 0) {
      const formatedRow = [];

      for (let i = 0; i < openOrders.length; i++) {
        if (openOrders[i]?.status === "Pending" && type === "close") {
          continue;
        }
        if (!shouldIncludeTradeByOpenOrderFilter(openOrders[i])) {
          continue;
        }
        const obj = {};
        const current = openOrders[i]?.side === "buy" ? "sell" : "buy";

        obj.pair = openOrders[i]?.symbol ? (
          <div className="display-1">
            {/* <img width="25" height="25" alt="gold-bars" /> */}
            {openOrders[i]?.symbol}
          </div>
        ) : (
          "-"
        );
        obj.side = openOrders[i]?.side === "buy" ? "Buy" : "Sell";
        obj.quantity = openOrders[i]?.quantity
          ? Number(openOrders[i]?.quantity).toFixed(3)
          : "-";
        obj.margin = openOrders[i]?.margin
          ? Number(openOrders[i]?.margin).toFixed(3)
          : "-";
        obj.price = openOrders[i]?.price
          ? Number(openOrders[i]?.price).toFixed(5)
          : "-";
        obj.current_price =
          openOrders[i]?.status === "Pending" ? (
            <span
              className={`${current +
                "-" +
                getSocketDomSymbol(openOrders[i]?.symbol)
                }`}
            >
              -
            </span>
          ) : (
            "-"
          );
        obj.closed_price = openOrders[i]?.closed_price ? (
          <span
            className={`closed_price-${openOrders[i]?.symbol
              .replace("/", "")
              .toUpperCase()}`}
          >
            {Number(openOrders[i]?.closed_price).toFixed(5)}
          </span>
        ) : (
          "-"
        );
        obj.pnl =
          openOrders[i]?.status === "Pending" ? (
            <span className={`pnl-${openOrders[i]?._id}`}>-</span>
          ) : Number(openOrders[i]?.profit) >= 0 ? (
            <span style={{ color: "#009A2C" }}>
              {Number(openOrders[i]?.profit).toFixed(2)}
            </span>
          ) : (
            <span style={{ color: "red" }}>
              {Number(openOrders[i]?.profit).toFixed(2)}
            </span>
          );
        obj.stop_loss = openOrders[i]?.stop_loss
          ? Number(openOrders[i]?.stop_loss).toFixed(5)
          : "-";
        obj.take_profit = openOrders[i]?.take_profit
          ? Number(openOrders[i]?.take_profit).toFixed(5)
          : "-";
        obj.status = openOrders[i]?.status === "Pending" ? "Opened" : "Closed";
        obj.open_time = openOrders[i]?.createdAt
          ? formatedDateTime(openOrders[i]?.createdAt)
          : "-";
        obj.close_time = openOrders[i]?.closed_at
          ? formatedDateTime(openOrders[i]?.closed_at)
          : "-";
        obj.action =
          openOrders[i]?.status === "Pending" ? (
            <Dropdown
              menu={{ items: items(openOrders[i]) }}
              trigger={["click"]}
            >
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  Edit
                  <EditOutlined />
                </Space>
              </a>
            </Dropdown>
          ) : (
            "-"
          );

        obj.close =
          openOrders[i]?.status === "Pending" ? (
            <Popconfirm
              title="Close the trade"
              description="Are you sure to close this trade?"
              onConfirm={() => {
                // closeTrade(openOrders[i]);
              }}
              // onCancel={cancel}
              okText="Yes"
              placement="left"
              cancelText="No"
            >
              <Button variant="solid" color="danger" disabled={load}>
                Close
              </Button>
            </Popconfirm>
          ) : (
            "-"
          );
        formatedRow.push(obj);
      }
      setData(formatedRow);
    } else if (tradeHistory?.length > 0 && type === "pending") {
      setData([]);
    }
  }, [tradeHistory, openOrders, orderAssetFilter, orderHistoryAssetFilter]);

  useEffect(() => {
    if (positions?.length > 0) {
      const formatedRow = [];

      for (let i = 0; i < positions.length; i++) {
        // if (positions[i]?.status === "Pending" && type === "close") {
        //   continue;
        // }
        const obj = {};

        obj.symbol = positions[i]?.symbol ? (
          <div className="display-1">
            {/* <img width="25" height="25" alt="gold-bars" /> */}
            {positions[i]?.symbol}
          </div>
        ) : (
          "-"
        );
        obj.direction = positions[i]?.direction === "buy" ? "Buy" : "Sell";
        obj.lot_size = positions[i]?.lot_size
          ? Number(positions[i]?.lot_size).toFixed(positions[i]?.qtyPrecision)
          : "-";
        obj.margin =
          positions[i]?.status == "init" ||
            positions[i]?.status == "partially filled" ? (
            <span className={`margin-${positions[i]?._id}`}>
              {positions[i]?.margin}
            </span>
          ) : (
            Number(positions[i]?.margin)?.toFixed(positions[i]?.pricePrecision)
          );
        obj.entry_price = positions[i]?.entry_price
          ? Number(positions[i]?.entry_price).toFixed(
            positions[i]?.pricePrecision,
          )
          : "-";
        obj.current_price =
          positions[i]?.status == "init" ||
            positions[i]?.status == "partially filled" ? (
            <span
              className={`current-${positions[i]?.symbol
                .replace("_", "")
                .toUpperCase()}`}
            >
              -
            </span>
          ) : (
            "-"
          );
        obj.closed_price = positions[i]?.closed_price ? (
          <span
            className={`closed_price-${positions[i]?.symbol
              .replace("/", "")
              .toUpperCase()}`}
          >
            {Number(positions[i]?.closed_price).toFixed(
              positions[i]?.pricePrecision,
            )}
          </span>
        ) : (
          "-"
        );
        obj.unrealized_pnl =
          positions[i]?.status == "init" ||
            positions[i]?.status == "partially filled" ? (
            <span className={`pnl-${positions[i]?._id}`}>-</span>
          ) : Number(positions[i]?.profit) >= 0 ? (
            <span style={{ color: "#009A2C" }}>
              {Number(positions[i]?.profit).toFixed(5)}
            </span>
          ) : (
            <span style={{ color: "red" }}>
              {Number(positions[i]?.profit).toFixed(5)}
            </span>
          );
        obj.stop_loss = positions[i]?.stop_loss
          ? Number(positions[i]?.stop_loss).toFixed(
            positions[i]?.pricePrecision,
          )
          : "-";
        obj.take_profit = positions[i]?.take_profit
          ? Number(positions[i]?.take_profit).toFixed(
            positions[i]?.pricePrecision,
          )
          : "-";
        obj.status =
          positions[i]?.status === "init"
            ? "Opened"
            : positions[i]?.status === "partially filled"
              ? "Partially filled"
              : "Closed";
        obj.open_time = positions[i]?.createdAt
          ? formatedDateTime(positions[i]?.createdAt)
          : "-";
        obj.close_time = positions[i]?.closed_at
          ? formatedDateTime(positions[i]?.closed_at)
          : "-";
        obj.action =
          positions[i]?.status == "init" ||
            positions[i]?.status == "partially filled" ? (
            <Dropdown menu={{ items: items(positions[i]) }} trigger={["click"]}>
              <a onClick={(e) => e.preventDefault()}>
                <Space>
                  Edit
                  <EditOutlined />
                </Space>
              </a>
            </Dropdown>
          ) : (
            "-"
          );

        obj.close =
          positions[i]?.status == "init" ||
            positions[i]?.status == "partially filled" ? (
            <Popconfirm
              title="Close the trade"
              description="Are you sure to close this trade?"
              onConfirm={() => {
                closeFuturePosition(positions[i]);
              }}
              // onCancel={cancel}
              okText="Yes"
              placement="left"
              cancelText="No"
            >
              <Button variant="solid" color="danger" disabled={load}>
                Close
              </Button>
            </Popconfirm>
          ) : (
            "-"
          );
        formatedRow.push(obj);
      }
      setPosData(formatedRow);
    } else {
      setPosData([]);
    }
  }, [positions]);

  const expandVariant = {
    collapsed: {
      opacity: 0,
      height: 0,
      y: 30,
      overflow: "hidden",
      transition: {
        opacity: { duration: 0.25, ease: "easeOut" },
        height: { duration: 0.45, ease: [0.25, 0.1, 0.25, 1] },
        y: { duration: 0.45, ease: "easeOut" },
      },
    },
    expanded: {
      opacity: 1,
      height: "auto",
      y: 0,
      overflow: "hidden",
      transition: {
        type: "spring",
        stiffness: 80,
        damping: 15,
        mass: 0.8,
        duration: 0.55,
        when: "beforeChildren",
        staggerChildren: 0.08,
        delayChildren: 0.1,
      },
    },
  };

  const handleLoading = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
    }, 1500);
  };

  return (
    <>
      {!isMobilePoint ? (
        <>
          <Tabs
            onChange={(value) => {
              setType(value);
              handleLoading();
              setCollapsedHistory(false);
            }}
            defaultActiveKey="margin"
            type="card"
            tabBarExtraContent={{
              right: (
                <div
                  onClick={() => {
                    setCollapsedHistory(!collapsedHistory);
                    handleLoading();
                  }}
                  style={{
                    cursor: "pointer",
                    color: "#aaa",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: 4,
                  }}
                >
                  <span className="position-table">
                    {!collapsedHistory ? "Hide positions" : "Show positions"}
                  </span>
                  <span className="position-table">
                    {!collapsedHistory ? <DownOutlined /> : <UpOutlined />}
                  </span>
                </div>
              ),
            }}
            className="trade-tab"
          >
            <TabPane tab={"Binary History"} key="binary">
              {/* <div className={`accordion - content ${ collapsed ? "collapsed" : "expanded" } `}> */}
              <AnimatePresence initial={false}>
                {!collapsedHistory && (
                  <motion.div
                    key="accordion-content"
                    variants={expandVariant}
                    initial="collapsed"
                    animate="expanded"
                    exit="collapsed"
                    className="accordion-content"
                  >
                    <TradeTable
                      columns={columns}
                      data={data}
                      scroll={{ y: 170, x: 1000 }}
                      className={"trade-table"}
                      loading={loading}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPane>
            <TabPane tab={"Order History"} key="close">
              <AnimatePresence initial={false}>
                {!collapsedHistory && (
                  <motion.div
                    key="accordion-content"
                    variants={expandVariant}
                    initial="collapsed"
                    animate="expanded"
                    exit="collapsed"
                    className="accordion-content"
                  >
                    <div className="display-4" id="cs">
                      <Select
                        value={orderHistoryAssetFilter}
                        style={{ width: "180px" }}
                        onChange={(value) => setOrderHistoryAssetFilter(value)}
                        className="history-select"
                        options={[
                          { value: "all", label: "Forex + Commodities" },
                          { value: "forex", label: "Forex" },
                          { value: "commodities", label: "Commodities" },
                        ]}
                      />
                    </div>
                    <TradeTable
                      columns={forexColumns}
                      data={data}
                      scroll={{ y: 170, x: 1000 }}
                      className={"trade-table"}
                      loading={loading}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPane>
            <TabPane tab={"Open Orders"} key="pending">
              <AnimatePresence initial={false}>
                {!collapsedHistory && (
                  <motion.div
                    key="accordion-content"
                    variants={expandVariant}
                    initial="collapsed"
                    animate="expanded"
                    exit="collapsed"
                    className="accordion-content"
                  >
                    <div className="display-4" id="cs">
                      <Select
                        value={orderAssetFilter}
                        style={{ width: "180px" }}
                        onChange={(value) => setOrderAssetFilter(value)}
                        className="history-select"
                        options={[
                          { value: "all", label: "Forex + Commodities" },
                          { value: "forex", label: "Forex" },
                          { value: "commodities", label: "Commodities" },
                        ]}
                      />
                    </div>
                    <TradeTable
                      columns={forexColumns2}
                      data={data}
                      scroll={{ y: 170, x: 1000 }}
                      className={"trade-table"}
                      loading={loading}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPane>
            <TabPane tab="Positions" key="positions">
              <AnimatePresence initial={false}>
                {!collapsedHistory && (
                  <motion.div
                    key="accordion-content"
                    variants={expandVariant}
                    initial="collapsed"
                    animate="expanded"
                    exit="collapsed"
                    className="accordion-content"
                  >
                    <TradeTable
                      columns={baseFutureColumn}
                      data={posData}
                      scroll={{ y: 170, x: 1000 }}
                      className={"trade-table"}
                      loading={loading}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPane>
          </Tabs>
          {aggregate?.quantity && type === "pending" && (
            <div className="liv-pnl display-2 gap-15">
              <div>
                Quantity:{" "}
                {aggregate.quantity
                  ? parseFloat(aggregate.quantity).toFixed(3)
                  : "-"}
              </div>
              <div>
                Side:{" "}
                <span style={{ textTransform: "capitalize" }}>
                  {aggregate?.side ? aggregate?.side : "-"}
                </span>
              </div>
              <div>
                Current Price:{" "}
                <span
                  className={`${aggregate?.side === "buy" ? "sell" : "buy"
                    }-${aggregate?.symbol?.replace("/", "")}`}
                ></span>
              </div>
              <div>
                P&L: <span className={`pnl-${aggregate?.id}`}></span>
              </div>
              {/* <Popconfirm
                    title="Delete the task"
                    description="Are you sure to close this trade?"
                    onConfirm={() => {
                        closeTrade(tradeHistory[0])
                    }}
                    // onCancel={cancel}
                    okText="Yes"
                    placement="left"
                    cancelText="No"
                >
                    <Button variant="solid" color="danger" style={{ height: "20px", padding: "0 24px", borderRadius: "3px" }} >
                        Close
                    </Button>
                </Popconfirm> */}
            </div>
          )}
          {!edit?.isFuture ? (
            <Modal
              title={
                <>
                  {val === 0 ? "Stop Loss" : "Take Profit"}
                  <EditOutlined style={{ marginLeft: 6 }} />
                </>
              }
              onCancel={() => handleCancel()}
              open={isModalOpen}
              footer={null}
              centered
              style={{ width: "300px" }}
              className="ant-edit-model"
            >
              <div
                onClick={(e) => e.stopPropagation()} // prevents close on click inside
              // style={{
              //     background: "var(--bg-mn)",
              //     border: "2px solid #00ae3333",
              //     padding: "10px",
              //     borderRadius: 8,
              // }}
              >
                <div
                  onClick={(e) => {
                    inputRef.current.focus({ cursor: "end" });
                  }} // 🧠 Prevent dropdown from closing
                  className="sltp-inp"
                >
                  <InputNumber
                    defaultValue={3}
                    style={{ width: "100%" }}
                    ref={inputRef}
                    value={pip}
                    onChange={(e) => {
                      handlePipChange(e);
                    }}
                  />
                </div>
                <div
                  onClick={(e) => {
                    inputRefPip.current.focus({ cursor: "end" });
                  }} // 🧠 Prevent dropdown from closing
                  className="sltp-inp mt-10"
                >
                  <InputNumber
                    defaultValue={3}
                    addonBefore="$"
                    style={{ width: "100%" }}
                    ref={inputRefPip}
                    value={sltp}
                    onChange={(e) => {
                      handleSlTpChange(e);
                    }}
                  />
                  {/* <div style={{ textAlign: "right", marginTop: "3px", color: "var(--fnt)" }}>
                            199 pips
                        </div> */}
                </div>
                <Button
                  variant="solid"
                  color="primary"
                  style={{
                    width: "100%",
                    marginTop: "5px",
                    backgroundColor: "rgb(0, 154, 44)",
                  }}
                  onClick={(e) => {
                    updateTrade();
                  }}
                >
                  <CheckOutlined /> Confirm
                </Button>
              </div>
            </Modal>
          ) : (
            <Modal
              title={
                <>
                  {val === 0 ? "Stop Loss" : "Take Profit"}
                  <EditOutlined style={{ marginLeft: 6 }} />
                </>
              }
              onCancel={() => handleCancel()}
              open={isModalOpen}
              footer={null}
              centered
              style={{ width: "300px" }}
              className="ant-edit-model"
            >
              <div
                onClick={(e) => e.stopPropagation()} // prevents close on click inside
              // style={{
              //     background: "var(--bg-mn)",
              //     border: "2px solid #00ae3333",
              //     padding: "10px",
              //     borderRadius: 8,
              // }}
              >
                <div
                  onClick={(e) => {
                    inputRef.current.focus({ cursor: "end" });
                  }} // 🧠 Prevent dropdown from closing
                  className="sltp-inp"
                >
                  <InputNumber
                    defaultValue={0}
                    style={{ width: "100%" }}
                    ref={inputRef}
                    value={futureSlTp}
                    onChange={(e) => {
                      if (String(e).length > 15) return;
                      handleFutureTpSlChange(e);
                    }}
                  />
                </div>
                <div
                  onClick={(e) => {
                    inputRefPip.current.focus({ cursor: "end" });
                  }} // 🧠 Prevent dropdown from closing
                  className="sltp-inp mt-10"
                >
                  <InputNumber
                    defaultValue={0}
                    addonBefore="$"
                    style={{ width: "100%" }}
                    ref={inputRefPip}
                    value={futureSlTpMoney}
                    onChange={(e) => {
                      if (String(e).length > 15) return;
                      handleFutureTpSlMoneyChange(e);
                    }}
                  />
                </div>
                <Button
                  variant="solid"
                  color="primary"
                  style={{
                    width: "100%",
                    marginTop: "5px",
                    backgroundColor: "rgb(0, 154, 44)",
                  }}
                  onClick={(e) => {
                    updateFutureTrade();
                  }}
                >
                  <CheckOutlined /> Confirm
                </Button>
              </div>
            </Modal>
          )}
        </>
      ) : (
        <div className="portfolio-wrapper">
          <div className="p-10">
            <div className="total-invest-text">
              Total Investment
              <InfoCircleOutlined />
            </div>
            <small>$0.00</small>
          </div>

          <Tabs
            onChange={(value) => {
              console.log(value, "value DATA");
              setType(value);
              handleLoading();
              setCollapsedHistory(false);
            }}
            defaultActiveKey="margin"
            type="card"
            className="trade-mobile-tab"
            tabBarExtraContent={<RightOutlined style={{ color: "#fff" }} />}
          >
            <TabPane tab={"Binary History"} key="binary">
              {/* <div className={`accordion - content ${ collapsed ? "collapsed" : "expanded" } `}> */}
              <AnimatePresence initial={false}>
                {!collapsedHistory && (
                  <motion.div
                    key="accordion-content"
                    variants={expandVariant}
                    initial="collapsed"
                    animate="expanded"
                    exit="collapsed"
                  // className="accordion-content"
                  >
                    <TradeTable
                      columns={columns}
                      data={data}
                      scroll={{ x: 1000 }}
                      className={"trade-table"}
                      loading={loading}
                      onRow={handleRow}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPane>
            <TabPane tab={"Order History"} key="close">
              {/* <div className={`accordion - content ${ collapsed ? "collapsed" : "expanded" } `}> */}
              <AnimatePresence initial={false}>
                {!collapsedHistory && (
                  <motion.div
                    key="accordion-content"
                    variants={expandVariant}
                    initial="collapsed"
                    animate="expanded"
                    exit="collapsed"
                  // className="accordion-content"
                  >
                    <div className="display-4" id="cs">
                      <Select
                        value={orderHistoryAssetFilter}
                        style={{ width: "180px" }}
                        onChange={(value) => setOrderHistoryAssetFilter(value)}
                        className="history-select"
                        options={[
                          { value: "all", label: "Forex + Commodities" },
                          { value: "forex", label: "Forex" },
                          { value: "commodities", label: "Commodities" },
                        ]}
                      />
                    </div>
                    <TradeTable
                      columns={forexColumns}
                      data={data}
                      scroll={{ x: 1000 }}
                      className={"trade-table"}
                      loading={loading}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPane>
            <TabPane tab={"Open Orders"} key="pending">
              <AnimatePresence initial={false}>
                {!collapsedHistory && (
                  <motion.div
                    key="accordion-content"
                    variants={expandVariant}
                    initial="collapsed"
                    animate="expanded"
                    exit="collapsed"
                  // className="accordion-content"
                  >
                    <TradeTable
                      columns={forexColumns2}
                      data={data}
                      scroll={{ x: 1000 }}
                      className={"trade-table"}
                      loading={loading}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPane>
            <TabPane tab="Positions" key="positions">
              <AnimatePresence initial={false}>
                {!collapsedHistory && (
                  <motion.div
                    key="accordion-content"
                    variants={expandVariant}
                    initial="collapsed"
                    animate="expanded"
                    exit="collapsed"
                    className="accordion-content"
                  >
                    <TradeTable
                      columns={baseFutureColumn}
                      data={posData}
                      scroll={{ x: 1000 }}
                      className={"trade-table"}
                      loading={loading}
                    />
                  </motion.div>
                )}
              </AnimatePresence>
            </TabPane>
          </Tabs>

          {/* <div className="portfolio-active">
            <h6>Active</h6>
            <div className="mt-10">
              <motion.div
                key="accordion-content"
                variants={expandVariant}
                initial="collapsed"
                animate="expanded"
                exit="collapsed"
                className="accordion-content"
              >
                <TradeTable
                  columns={forexColumns2}
                  data={data}
                  scroll={{ y: 150 }}
                  className={"trade-table"}
                  loading={loading}
                />
              </motion.div>
            </div>
          </div>

          <div className="portfolio-closed">
            <h6>Binary History</h6>

            <div className="mt-10">
              <motion.div
                key="accordion-content"
                variants={expandVariant}
                initial="collapsed"
                animate="expanded"
                exit="collapsed"
                className="accordion-content"
              >
                <TradeTable
                  columns={columns}
                  data={data}
                  scroll={{ y: 150 }}
                  className={"trade-table"}
                  loading={loading}
                />
              </motion.div>
            </div>
          </div>
          <div className="portfolio-closed">
            <h6>Order History</h6>

            <div className="mt-10">
              <motion.div
                key="accordion-content"
                variants={expandVariant}
                initial="collapsed"
                animate="expanded"
                exit="collapsed"
                className="accordion-content"
              >
                <TradeTable
                  columns={forexColumns}
                  data={data}
                  scroll={{ y: 150 }}
                  className={"trade-table"}
                  loading={loading}
                />
              </motion.div>
            </div>
          </div> */}
        </div>
      )}

      <div className="bottom-drawer">
        <Drawer
          title="Your accounts"
          placement={"bottom"}
          // onClose={onCloseAccount}
          open={mobileDraw}
          closable={true}
          getContainer={false}
          closeIcon={<CloseOutlined style={{ color: "#888" }} />}
        ></Drawer>
      </div>
    </>
  );
};

export default SmoothAccordionTabs;
